export const CoreFollowedIdMapName = 'CoreFollowedIdMap';
